import { useEffect } from 'react'
import * as R from 'ramda'

import keyCodes from 'src/lib/util/keyCodes'

/*
  Executes functions when defined keys are pressed (on keyup)

  USAGE
    ```
    useKeyHandlers(
      node,
      {
        [keyCode]: () => void
      },
      [watch1, watch2, etc]
    )
    ```
*/

const useKeyHandlers = (node, keyMap, subscriptions) =>
  useEffect(() => {
    const doAttach = R.is(Node, node) && keyMap

    if (doAttach) {
      const getKeyCode = key => (R.is(Number, key) ? key : keyCodes[key])

      const handleKeys = event => {
        const keyCode = event.which || event.keyCode

        Object.entries(keyMap).forEach(([key, handler]) => {
          if (getKeyCode(key) === keyCode || key === event.key) {
            handler(event)
          }
        })
      }

      node.addEventListener('keyup', handleKeys)

      return () => node.removeEventListener('keyup', handleKeys)
    }
  }, subscriptions || null)

export default useKeyHandlers
